export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/sparkles-icon.png?49cadd4e938a9087967339b7ca97d9d5";